import type { GameModule } from '../types';
import Page from './Page';

const xo: GameModule = {
  id:          'xo',
  displayName: 'X & O',
  tag:         'Strategy',
  theme: {
    gradient: 'from-teal-500 to-emerald-800',
    emoji:    '⨯',
    logo:     '/games/xo/Logo.png',
  },
  // 3×3 board + on-screen score chips read cleanly only in portrait.
  orientation: 'portrait',
  Page,
  adminIcon: 'grid_3x3',
  adminTheme: {
    headerFrom:  'from-teal-900',
    headerTo:    'to-emerald-800',
    ring:        'ring-emerald-400',
    accent:      'bg-emerald-600',
    accentHover: 'hover:bg-emerald-500',
    dot:         'bg-emerald-400',
    softBg:      'bg-teal-900/30',
    rangeAccent: 'accent-emerald-500',
    badgeClasses: 'bg-teal-600/20 text-teal-300 border-teal-600/30',
  },
};

export default xo;
